// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid__Grid_2oRtm {\n  display: grid;\n  grid-gap: 15px;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n}\n", ""]);
// Exports
exports.locals = {
	"grid": "grid__Grid_2oRtm"
};
module.exports = exports;
